import { approvalList } from '@/api/approvalTask';
const baseUrl = '/v1/role';
export default {
  namespaced: true,
  state: {
    totalCount: 0,
    dataSource: [],
    filter: {}
  },
  mutations: {
    SAVE_STATE (state, payload = {}) {
      // 由于不想全部把state给改了，所以我想把每一个数据都单独塞一下
      const keyList = Object.keys(payload);
      keyList.forEach(key => {
        state[key] = payload[key];
      });
    }
  },
  actions: {
    getTableInfo ({ commit, dispatch, state }, { filter }) {
      const pasFilter = { ...filter };
      approvalList(pasFilter).then(res => {
        const { code, data } = res.data;
        if (code == 200) {
          commit('SAVE_STATE', { dataSource: data.records, totalCount: data.total, filter });
        }
      });
    },
    submitTempGroup ({ commit }, { formData, idEdit }) {
      return new Promise(resolve => {
        // 提交
        // 通过 idEdit 判断是否是编辑的地址啥的
        console.log('formData', formData);
        resolve(true);
      });
    },
    getDetail ({ commit, dispatch, state }, { id }) {
      console.log('id', id);
    }
  }
};
